import ApplicationRouter from './application-router';
export default ApplicationRouter;
